module.exports = __webpack_public_path__ + "static/img/inter-cirle-two.df6c79c5.png";